export function extractDuplicatePostId(data: unknown): number | null {
  const payload = data as {
    existing_post_id?: unknown
    duplicate_of?: unknown
    detail?: {
      existing_post_id?: unknown
      duplicate_of?: unknown
    }
  } | null

  const candidates = [
    payload?.existing_post_id,
    payload?.duplicate_of,
    payload?.detail?.existing_post_id,
    payload?.detail?.duplicate_of,
  ]

  for (const candidate of candidates) {
    const value = typeof candidate === 'string' ? Number(candidate) : candidate
    if (typeof value === 'number' && Number.isInteger(value) && value > 0) {
      return value
    }
  }

  return null
}
